import React, { Component } from 'react'
import { Card, Grid, Icon } from '@softwaredev_cegeka/stix-core'
import './unauthorizedCard.scss'
import { observer } from 'mobx-react'

class UnauthorizedCard extends Component {
    render() {
        const { warningText = 'You are not authorized to access this data.' } =
            this.props
        return (
            <Grid.Row>
                <Grid.Col md={{ offset: 4, span: 4 }}>
                    <Card className={'unauthorized-card'}>
                        <Card.Body>
                            <Icon icon={'lock'} />
                            <div className={'unauthorized-content'}>
                                <Card.Title className={'unauthorized-title'}>
                                    Unauthorized
                                </Card.Title>
                                <p>{warningText}</p>
                            </div>
                        </Card.Body>
                    </Card>
                </Grid.Col>
            </Grid.Row>
        )
    }
}

export default observer(UnauthorizedCard)
